// later to be refactored into scenario pinia store getter

import type { Scenario } from "@/composables/forms/formTypes";
import { loadUnitPreset, presetNameShowsOilRates } from "@/libs/units/presets";
import { updatedDiff } from "./diff";
import { isEmptyObject } from "./utils";
import type { DisplayUnitsQuery } from "gql/api";

export const getScenarioUnitSystem = (
  displayUnits?: DisplayUnitsQuery,
  scenario?: Scenario | null
) => {
  if (!scenario) return null;
  // Get generic keys from override blob. If none, it's an older scenario and mark it custom
  const scenarioGenericKeys = Object.fromEntries(
    Object.entries(scenario?.display_unit_overrides || {}).filter(
      k => k[0].indexOf("Generic.") === 0
    )
  );
  if (isEmptyObject(scenarioGenericKeys)) {
    return null;
  }

  const matchedUnitSystem = displayUnits?.display_units.find(du =>
    isEmptyObject(updatedDiff(scenarioGenericKeys, loadUnitPreset(du.value)))
  );
  if (matchedUnitSystem) {
    return matchedUnitSystem;
  }

  return null;
};
export const shouldShowOilRates = (
  displayUnits?: DisplayUnitsQuery,
  scenario?: Scenario | null
) => {
  return presetNameShowsOilRates(
    getScenarioUnitSystem(displayUnits, scenario)?.value
  );
};

type SizingParam = {
  id?: string;
  installed_scenario_id?: string | null;
  scenario_order?: (string | null)[] | null;
  scenarios?: ({ id?: string } | null | undefined)[] | null;
};

export const orderScenariosBySizingOrder = <T extends { id?: string }>(
  sizing?: SizingParam | null,
  scenarios?: Array<T | null | undefined> | null
): T[] => {
  const scenarioList = (scenarios || []).filter(
    (scenario): scenario is T => !!scenario
  );
  const scenarioOrder = (sizing?.scenario_order || []).filter(
    (id): id is string => !!id
  );

  if (!scenarioOrder.length) {
    return scenarioList;
  }

  const scenarioById = new Map<string, T>();
  for (const scenario of scenarioList) {
    if (!scenario.id) continue;
    scenarioById.set(scenario.id, scenario);
  }

  const ordered: T[] = [];
  for (const id of scenarioOrder) {
    const scenario = scenarioById.get(id);
    if (scenario) ordered.push(scenario);
  }

  for (const id of scenarioOrder) {
    scenarioById.delete(id);
  }

  return [...ordered, ...Array.from(scenarioById.values())];
};

export const getInstalledOrLatestScenarioId = (
  sizing?: SizingParam | null,
  scenarios?: ({ id?: string } | null | undefined)[] | null
) => {
  const installed = sizing?.installed_scenario_id;
  if (installed) return installed;
  return orderScenariosBySizingOrder(sizing, scenarios).at(-1)?.id;
};

export const getRouteParamsFromSizing = (
  sizing?: SizingParam | null,
  defaultScenarioToNew = false
) => {
  const params: { sizingId?: string; scenarioId: string } = {
    scenarioId: "new"
  };
  if (sizing?.id) {
    params.sizingId = sizing.id;
  }
  const scenarioId = getInstalledOrLatestScenarioId(sizing, sizing?.scenarios);
  if (scenarioId) {
    params.scenarioId = scenarioId;
  } else if (defaultScenarioToNew) {
    params.scenarioId = "new";
  }
  return params;
};
